import { Flex } from "@similarweb/ui-components/foundations";

import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { getExcelButtonText } from "app/components/React/ExcelButton/getExcelButtonText";

// The package's Settings drops the Excel button when `excelDownloadUrl` is empty and has no
// locked state, so users without Excel access (e.g. after trial) would lose the upsell
// affordance. DownloadButtonMenu's locked variant opens the "DownloadExcel" hook modal.
export const LockedExcelButton = () => (
    <Flex
        flex="1"
        justifyContent="flex-end"
        alignItems="center"
        data-automation="website-rankings-table-excel-locked"
    >
        <DownloadButtonMenu
            Excel
            excelLocked
            buttonText={getExcelButtonText()}
        />
    </Flex>
);
